import { Form } from 'factorial-form'

export class OperatorForm extends Form {
  constructor(values: Record<string, any>) {
    super(values, {
      value: 'string',
    })
  }
}
